module.exports = __webpack_public_path__ + "media/images/senior_home_image-40f46246.png";